export const boardData = {
  Tabs: [
    "Social Listening",
    "Online Reputation",
    "Social CRM",
    "Social Analytics",
    "Social Publishing",
    "Surveys & Feedback",
    "BI Tools & Dashboards",
    "Crisis Management",
  ],
  Tab1: [
    {
      heading: "Listen to online web, Social Media and a lot more",
      subheading:
        "Do not miss out on any conversation anywhere on the web. Listen to your customer's voice, engage with them and make them happier",
    },
    {
      heading: "Get Market Intelligence",
      subheading:
        "Analyze customer data from anywhere on the web and social media. Get real-time market intelligence. Fine-tune your strategies and make valuable business decisions",
    },
    {
      heading: "Creative Asset Library",
      subheading:
        "Pre-save all your content, including text and media, in the creative asset library. Easily pick them up for publishing and scheduling, giving your design and content teams the flexibility to plan and execute your campaigns and festivals",
    },
  ],
  Tab2: [
    {
      heading: "Conversations as Tickets",
      subheading:
        "View all conversations related to your brand in the form of support tickets, which give you a detailed overview of the customers and their queries in terms of history, analytics, followers, and influence. Based on this, you can define priorities for response management",
    },
    {
      heading: "Escalations & auto assignment",
      subheading:
        "You have the flexibility to check with external teams who are not a part of the tool regarding responses through email escalations by adding the conversation details. You can also auto-assign queries to appropriate users/groups based on the rules you define, thus reducing time",
    },
    {
      heading: "Impact measurement",
      subheading:
        "Get a complete view of all the tickets that are at various stages of resolution, check TAT scores, and identify areas that need more action. Measure the impact by analyzing the difference in sentiment based on your efforts",
    },
  ],
  Tab3: [
    {
      heading: "Automation and workflows",
      subheading:
        "Workflows and automation such as queuing, ticket history, auto-assignment and classification, draft templates, and many more to ensure your agents are empowered to respond to and resolve queries in a timely manner",
    },
    {
      heading: "Agent performance",
      subheading:
        "Track and measure How are your agents performing with various TAT reports and SLAs to be able to identify the hits and misses and ensure the right actions are taken in terms of agent productivity?",
    },
    {
      heading: "One view of the customer",
      subheading:
        "Have all your customer query data points, including web and social, in one place to be able to have a holistic view of the customer, including the query history, details, etc, and use this information for better CXM",
    },
  ],
  Tab4: [
    {
      heading: "Analytics and Benchmarking",
      subheading:"With over 700 charts covering various aspects of listening, social media analytics, competitor analytics, and agent performance reports, you get a comprehensive and holistic view of your brand's perception and performance in terms of customer experience management and marketing"
    },
    {
      heading: "KISS - Konnect Insights Smart Suggestions",
      subheading:
        "In simple plain English, understand complex metrics that are easy to remember. Insights are presented in a way humans speak and with the right pictures. Understand what has worked for you and get suggestions on what will work for you with AI-powered smart suggestions",
    },
    {
      heading: "Content Strategy",
      subheading:"With all your insights in one platform, identify trends, pain points, hits and misses, moments when your audience is active, and much more to quickly shape align messaging into consumer-relevant and engagement-driven"
    },
  ],
  Tab5: [
    {
      heading: "Social Media Management",
      subheading:"Easily and effectively publish or schedule posts on social media across multiple channels and multiple accounts, simultaneously, preview them on different devices, and check them out on a content calendar for a 360-degree view of all your posts"
    },
    {
      heading: "Approval process",
      subheading:"Ensure the right and correct content goes live on social media channels using the approval-rejection feature, facilitating easy collaboration between brands, agencies, and teams for the right representation of the brand"
    },
    {
      heading: "Creative Asset Library",
      subheading:"Pre-save all your content, including text and media, in the creative asset library. Easily pick them up for publishing and scheduling, giving your design and content teams the flexibility to plan and execute your campaigns and festivals"
    },
  ],
  Tab6: [
    {
      heading: "Customer Satisfaction Surveys",
      subheading:"If your customers are really satisfied, Send Csat-Customer Satisfaction Surveys that are linked to your customer care module and learn from your customers about the agent's performance"
    },
    {
      heading: "Link to Social Listening",
      subheading:"Get the best ideas from those who matter the most—your customers. Analyze all insights in unified dashboards with classifications created for social listening"
    },
    {
      heading: "Market Research",
      subheading:"Expand your market research capabilities to keep track of your brand, test your ideas, or get a gut check with your target audience. Share learning across your organization"
    },
  ],
  Tab7: [
    {
      heading: "Customised Dashboards",
      subheading:"Create dashboards for various stakeholders by simply dragging and dropping charts from the chart library or charts created from BI tools. Bring in your external data sources too to create dashboards"
    },
    {
      heading: "Create your own charts",
      subheading:
        "Create any type of chart using advanced features such as pivoting, defining your own filters, columns, dimensions, and measures, which are completely tailored to your needs while going granular, equipping you with intelligent insights for better business decisions",
    },
    {
      heading: "Flexible reporting",
      subheading:"Shareable and collaborative dashboards and charts with the ability to add your own notes or inferences. You won't find the need to download data in excel spreadsheets or make ppts. Save time and share live dashboards"
    },
    {
        heading:"Themes and Brand colors",
        subheading:"Create your own themes to match your brand colors. Or define chart colors to match the brand and competition. Use various color palettes to make visually stunning dashboards"
    }
  ],
  Tab8:[
    {
        heading: "Identify crisis",
        subheading:"Ensure you are aware of any impending crisis that could affect your brand and be ready for it. Use keywords, hashtags and other parameters such as follower count, to monitor situations that can lead to crisis"
      },
      {
        heading: "Get notified real time",
        subheading:"Once you have defined the parameters to identify crises, you will get real time alerts based on them. You can ensure that you don't miss out on these notifications by choosing to be alerted on mobile apps and/or email"
      },
      {
        heading: "Take Action",
        subheading:"Prepare a crisis management and mitigation plan by looking at analytics and data. Respond to queries in real time and use workflows to enhance their productivity and TATs and identify and mobilise influencers to counter crises"
      },
  ]
};
